/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React from "react";
import * as S from "./styles";
import {
  PURE_BG,
  TRIBE_BG,
  CAL_BG,
  THE_LOST_TRIBE_BG,
  HARTS_BG,
  ROGUE_BG,
  SECRETS_BG,
} from "../../assets";
import { StorageModule } from "@vlinder-web/storage-module-react";
const is = require("is_js");

export interface IColoredBackground {}

export interface IContainedColoredBackground {
  children?: React.ReactNode;
}

export const getBandBackgroundImageUrl = () => {
  const storageSrv = StorageModule.getInstance();
  const localStorage = storageSrv?.get("currencyExchangeLocal", "local");

  if (
    is.existy(localStorage?.band) &&
    localStorage?.band.toLowerCase() === "tribe"
  ) {
    return TRIBE_BG;
  }

  if (
    is.existy(localStorage?.band) &&
    localStorage?.band.toLowerCase() === "cal"
  ) {
    return CAL_BG;
  }

  if (
    is.existy(localStorage?.band) &&
    localStorage?.band.toLowerCase() === "calkids"
  ) {
    return CAL_BG;
  }

  if (
    is.existy(localStorage?.band) &&
    localStorage?.band.toLowerCase() === "secrets"
  ) {
    return SECRETS_BG;
  }

  if (
    is.existy(localStorage?.band) &&
    localStorage?.band.toLowerCase() === "pure"
  ) {
    return PURE_BG;
  }

  if (
    is.existy(localStorage?.band) &&
    localStorage?.band.toLowerCase() === "the lost tribe"
  ) {
    return THE_LOST_TRIBE_BG;
  }

  if (
    is.existy(localStorage?.band) &&
    localStorage?.band.toLowerCase() === "harts"
  ) {
    return HARTS_BG;
  }

  if (
    is.existy(localStorage?.band) &&
    localStorage?.band.toLowerCase() === "rogue"
  ) {
    return ROGUE_BG;
  }

  return TRIBE_BG;
};

export const ColoredBackground = (props: IColoredBackground) => {
  return (
    <S.ColouredBackground
      style={{ backgroundImage: `url(${getBandBackgroundImageUrl()})` }}
    />
  );
};

export const ContainedColoredBackground = ({
  children,
}: IContainedColoredBackground) => {
  return (
    <S.ContainedSurface>
      <S.ContainedColouredBackground
        style={{ backgroundImage: `url(${getBandBackgroundImageUrl()})` }}
      />
      <S.ContainedContent>{children}</S.ContainedContent>
    </S.ContainedSurface>
  );
};

ColoredBackground.defaultProps = {};
